
import { ConfigContext } from "Utils/Contexts";
import { useContext, useEffect, useState } from "react";
import Recent from "./components/Recent/Recent";
import styles from "./ContinueConversation.module.scss";

export default function ContinueConversation(props) {

    const configContext = useContext(ConfigContext);
    const [thisConfig, setThisConfig] = useState(null);

    useEffect(() => {
        setThisConfig(configContext.containersMetaData.containers.continueConversation);
    }, [configContext]);

    return (
        <div className={styles.container}>
            <div className={styles.title}>{thisConfig?.title}</div>
            <div>{thisConfig?.message}</div>
            <Recent topThree></Recent>
        </div>
    )
}
